import { useState } from 'react'
import { useSelector } from 'react-redux';
import { Button, Container, Paper, TextField } from '@mui/material';

import logoSvg from '../../assets/img/logo.svg'


import SaveStatus from '../../UIComponents/SaveStatus';
import mapStateToProps from './mapStateToProps.js';

const LoginDialog = () => {

    const [ login, setLogin ] = useState('');
    const [ password, setPassword ] = useState('');

    const{
        user,
        userLogin,
    } = useSelector(mapStateToProps); 

    const onLogin = () => {
        userLogin({
            login,
            password,
        })
    }
    
    return (
        <Container maxWidth="xs">
            <div style={{height: "100vh"}}>
                <img src={logoSvg} alt="Логотип" width={396}/>
                <Paper elevation={3} style={{padding:"40px"}}>
                    <SaveStatus errShowTime={1000} successShowTime={500} dataObj={user} title="Вход в систему" />
                    <TextField
                        value={login}
                        onChange={(e)=>setLogin(e?.target?.value)}
                        label="Имя пользователя"
                        size="small"
                        variant="standard"
                        fullWidth
                    />
                    <TextField
                        value={password}
                        onChange={(e)=>setPassword(e?.target?.value)}
                        label="Пароль"
                        size="small"
                        variant="standard"
                        type="password"
                        fullWidth
                    />
                    <Button onClick={onLogin} style={{margin:"40px auto"}} variant="contained" color="primary" disabled={Boolean(user?.loading)} >Вход</Button>
                </Paper>
            </div>
        </Container>
    )
}

export default LoginDialog;